<template>
  <div id="app">
    <TheHeader />
    <main class="main-content">
      <router-view v-slot="{ Component, route }">
        <Transition :name="route.meta.transition || 'page'" mode="out-in">
          <component :is="Component" :key="route.path" />
        </Transition>
      </router-view>
    </main>
    <TheFooter />
    <WhatsAppWidget />
    <CartSidebar />
    <ToastNotification />
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
import TheHeader from '@/components/layout/TheHeader.vue'
import TheFooter from '@/components/layout/TheFooter.vue'
import WhatsAppWidget from '@/components/common/WhatsAppWidget.vue'
import CartSidebar from '@/components/cart/CartSidebar.vue'
import ToastNotification from '@/components/common/ToastNotification.vue'
import { useSettingsStore } from '@/stores/settings'
import { useCartStore } from '@/stores/cart'

const settingsStore = useSettingsStore()
const cartStore = useCartStore()

onMounted(() => {
  // Initialize CMS settings on app load
  settingsStore.init()
  // Initialize cart from localStorage
  cartStore.loadLocalCart()
})
</script>

<style lang="scss">
@import '@/assets/styles/main.scss';

#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.main-content {
  flex: 1;
}

// Page Transitions
.page-enter-active,
.page-leave-active {
  transition: opacity 0.4s ease, transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.page-enter-from {
  opacity: 0;
  transform: translateY(20px);
}

.page-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}

// Fade transition variant
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

// Slide transition variant
.slide-enter-active,
.slide-leave-active {
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.slide-enter-from {
  opacity: 0;
  transform: translateX(30px);
}

.slide-leave-to {
  opacity: 0;
  transform: translateX(-30px);
}

// Scale transition variant
.scale-enter-active,
.scale-leave-active {
  transition: all 0.3s ease;
}

.scale-enter-from {
  opacity: 0;
  transform: scale(0.95);
}

.scale-leave-to {
  opacity: 0;
  transform: scale(1.05);
}
</style>
